module.exports = __webpack_public_path__ + "appstore/static/img/footer-mobile.629fe7d.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/assets/footer-mobile.png
// module id = T+UK
// module chunks = 1